import { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import { getFirebaseServices, type FirebaseServices } from '../../services/firebase/client';

const FirebaseContext = createContext<FirebaseServices | null>(null);

export function FirebaseProvider({ children }: PropsWithChildren): React.JSX.Element {
  const services = useMemo(() => getFirebaseServices(), []);
  return <FirebaseContext.Provider value={services}>{children}</FirebaseContext.Provider>;
}

export function useFirebase(): FirebaseServices {
  const context = useContext(FirebaseContext);
  if (!context) throw new Error('useFirebase deve ser usado dentro de FirebaseProvider.');
  return context;
}
